<template>
  <div id="app">
    <sidebar v-if="!isFullEditor && $route.name !== 'Login' && $route.name !== 'account-manager' && $route.name !== 'account-vip-manager'"></sidebar>
    <top-bar v-if="!isFullEditor && $route.name !== 'Login' && $route.name !== 'account-manager' && $route.name !== 'account-vip-manager'"></top-bar>
    <div v-if="!isFullEditor && $route.name !== 'Login' && $route.name !== 'account-manager' && $route.name !== 'account-vip-manager'" class="main-container">
      <router-view/>
    </div>
    <div v-if="isAiPreviewPath">
      <router-view v-if="$route.name === 'AiPreview'"/>
    </div>
    <div v-else-if="isFullEditor" :style="{ marginTop: isAnimationEngine ? '0' : '30px' }">
      <router-view/>
    </div>
    <div v-if="$route.name === 'Login'">
      <router-view/>
    </div>
    <div v-if="$route.name === 'account-manager' || $route.name === 'account-vip-manager'">
      <router-view/>
    </div>
    <app-footer v-if="!isFullEditor && $route.name !== 'Login' && $route.name !== 'account-manager' && $route.name !== 'account-vip-manager'"></app-footer>
  </div>
</template>

<script>
import Sidebar from './views/components/Sidebar.vue'
import TopBar from './views/components/TopBar.vue'
import RightToolbar from './views/components/RightToolbar.vue'
import AppAppFooter from './views/components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    Sidebar,
    TopBar,
    RightToolbar,
    AppAppFooter
  },
  computed: {
    isAiPreviewPath() {
      return this.$route.name === 'AiPreview' || this.$route.path.startsWith('/ai-preview/')
          || window.location.pathname.startsWith('/ai-preview/');
    },
    isAnimationEngine() {
      return this.$route.name === 'AnimationEngine' || this.$route.name === 'AnimationEngineProject'
          || this.isAiPreviewPath;
    },
    isFullEditor() {
      return this.$route.name === 'Editor' || this.$route.name === 'EditorMe'
          || this.$route.name === 'AutonomousAvatar' || this.$route.name === 'AutonomousAvatarProject'
          || this.isAnimationEngine;
    }
  }
}
</script>


<style>
/* 导入重置样式表 */
@import './assets/css/reset.css';

/* 设置应用根元素样式 */
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  overflow-x: hidden; /* 隐藏水平滚动条 */
}

.main-container {
  margin-left: 175px;
  margin-right: 0;
  margin-top: 50px;
  min-height: calc(100vh - 60px);
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Element UI 全局样式调整 */
.el-button--primary {
  background-color: #6366f1;
  border-color: #6366f1;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: #5558e3;
  border-color: #5558e3;
}

.el-link.el-link--primary {
  color: #6366f1;
}

.el-link.el-link--primary:hover {
  color: #5558e3;
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #6366f1;
  border-color: #6366f1;
}
</style>
